import ApiInstance from './ApiInstance.js'

export default {
  
  getQualification() {
    return ApiInstance({ requiresAuth: true }).get('/qualification');
  },
  addQualification(Data) {
    return ApiInstance({ requiresAuth: true }).post('/qualification', Data);
  },
  editQualification(Data, id)
  {
    return ApiInstance({ requiresAuth: true }).put(`/qualification/${id}`, Data);
  },
  deleteQualification(id)
  {
    return ApiInstance({ requiresAuth: true }).delete(`/qualification/${id}`);
  }
}
